import ArrowOutwardIcon from '@mui/icons-material/ArrowOutwardRounded';
import GitHubIcon from '@mui/icons-material/GitHub';
import Images from '../utility/Images';
import { PROJECTS_URL } from '../utility/ProjectCatalog';
import { useMagnetic, useTilt } from '../utility/motion';

const SHOWCASE_ICONS = [
    Images.iptvisionIcon,
    Images.memshotIcon,
    Images.topperiaIcon,
    Images.devdexIcon,
    Images.mappinandoIcon,
    Images.appuntoIcon,
    Images.streamwiseLogo,
    Images.sweepIcon,
];

function OpenSource({checked}) {
    const cardRef = useTilt(4);
    const buttonRef = useMagnetic(0.2);

    return (
        <section className="section open-source" id="open-source" aria-labelledby="open-source-title">
            <div className="section__head" data-reveal>
                <span className="eyebrow"><span className="eyebrow__index">03</span>Open source</span>
            </div>

            <div className="showcase card tilt" ref={cardRef} data-reveal>
                <span className="card__spotlight" aria-hidden="true" />
                <span className="showcase__border" aria-hidden="true" />

                <div className="showcase__copy">
                    <span className="mono showcase__kicker">
                        <GitHubIcon className="showcase__kicker-icon" />
                        {checked ? 'Il mio catalogo di progetti' : 'My project catalog'}
                    </span>
                    <h2 className="showcase__title" id="open-source-title">
                        {checked ? 'Dalle idee alle cose che uso.' : 'From ideas to things I use.'}
                    </h2>
                    <p className="showcase__text">
                        {checked
                            ? 'App, giochi e strumenti per il web e il desktop. Esplora CeccaStore per scoprire i miei progetti e trovare dettagli e download.'
                            : 'Apps, games and tools for the web and desktop. Explore CeccaStore to discover my projects, details and downloads.'}
                    </p>
                    <a ref={buttonRef} href={PROJECTS_URL} className="btn btn--primary magnetic">
                        <span>{checked ? 'Esplora i progetti' : 'Explore projects'}</span>
                        <ArrowOutwardIcon className="btn__icon" />
                    </a>
                </div>

                <div className="showcase__visual" aria-hidden="true">
                    <div className="icon-cloud">
                        {SHOWCASE_ICONS.map((icon, index) => (
                            <span
                                key={icon}
                                className="icon-cloud__item"
                                style={{ '--i': index, '--n': SHOWCASE_ICONS.length }}
                            >
                                <img src={icon} alt="" loading="lazy" />
                            </span>
                        ))}
                        <span className="icon-cloud__core">CS</span>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default OpenSource;
